"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviewMode = exports.PREVIEW_PARAM_NAME = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const PREVIEW_PARAM_NAME = exports.PREVIEW_PARAM_NAME = 'previewEditorialPage';
const getPreviewMode = request => {
  // Works with SSG, SSR and CSR
  const enable = (0, _presentationUtils.getTypedQueryParam)({
    name: PREVIEW_PARAM_NAME,
    validate: value => {
      if (value === 'true') {
        return true;
      } else if (value === 'false') {
        return false;
      }
      return null;
    },
    req: request
  });
  return enable ?? false;
};
exports.getPreviewMode = getPreviewMode;
